import { createFileRoute } from '@tanstack/react-router';

import { guardPermitAdminRoute } from '../modules/Permits/permitAdminRouteGuard';
import { PermitGroupCreatePage } from '../modules/Permits/PermitsAdminPage/PermitGroupCreatePage';

// "New permit request" (creating a group) is its own page with Back (86bc85juw).
export const Route = createFileRoute('/permitting_/new')({
  component: PermitGroupCreatePage,
  loader({ context }) {
    guardPermitAdminRoute(context.authContext.user);
  },
  head() {
    return {
      meta: [{ title: 'New permit request' }],
    };
  },
});
